export default "__VITE_ASSET__DHy9TQn2__"